export default "__VITE_ASSET__0xhhK8Yn__"